import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { handleError } from '../store/features/alertSlice';

export function useErrorHandling(callback, onFinally = null, onError = null) {
  const dispatch = useDispatch();
  const onFinallyCallback = useMemo(() => onFinally || (() => {}), [onFinally]);
  const onErrorCallback = useMemo(() => onError || (() => {}), [onError]);

  const errorHandler = useCallback(
    async (...callbackParams) => {
      try {
        return await callback(...callbackParams);
      } catch (error) {
        dispatch(handleError(error));
        onErrorCallback(error)
      } finally {
        onFinallyCallback();
      }
    },
    [callback, dispatch, onErrorCallback, onFinallyCallback]
  );
  return errorHandler;
}
